import React from "react";
import L from "leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import "./SensorClusterGroup.css";

const createClusterIcon = (cluster) => {
  const count = cluster.getChildCount();
  const size = count < 10 ? 42 : count < 50 ? 48 : 56;
  const sizeClass =
    count < 10 ? "is-small" : count < 50 ? "is-medium" : "is-large";

  return L.divIcon({
    className: "sensor-map-cluster-div-icon",
    html: `<span class="sensor-map-cluster ${sizeClass}" aria-label="${count}"><span>${count}</span></span>`,
    iconSize: L.point(size, size, true),
  });
};

const getClusterRadius = (zoom) => {
  if (zoom < 8) return 76;
  if (zoom < 12) return 62;
  if (zoom < 15) return 48;
  return 36;
};

const SensorClusterGroup = ({ children }) => (
  <MarkerClusterGroup
    chunkedLoading
    animate
    maxClusterRadius={getClusterRadius}
    iconCreateFunction={createClusterIcon}
    showCoverageOnHover={false}
    zoomToBoundsOnClick
    spiderfyOnMaxZoom
    removeOutsideVisibleBounds
  >
    {children}
  </MarkerClusterGroup>
);

export default SensorClusterGroup;
